






















import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { Pracovnik } from '@/modules/administrace/pracovnik';

import { store } from '../store/edit';

export default Vue.extend({
	name: 'DoplnujiciInformace',
	components: {
		PracovnikSelect: Pracovnik.components.Select,
	},
	props: {
		storeUri: { type: String, required: true },
	},
	computed: {
		...genVuexComputeds(store),
	},
});
